import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Observable } from "rxjs";
import { FormControl } from "@angular/forms";
import { map, startWith } from "rxjs/operators";

interface Option {
  id: number;
  name: string;
}

@Component({
  selector: "kt-multi-dropdown-menu-with-search",
  templateUrl: "./multi-dropdown-menu-with-search.component.html",
})
export class MultiDropdownMenuWithSearchComponent implements OnInit {
  @ViewChild("search") searchTextBox: ElementRef;

  searchTextboxControl = new FormControl("");
  @Input() data: Option[] = [];
  @Input() control: FormControl;

  filteredOptions: Observable<Option[]>;

  ngOnInit() {
    this.filteredOptions = this.searchTextboxControl.valueChanges.pipe(
      startWith<string>(""),
      map((name) => this._filter(name))
    );
  }
  get firstSelectedName(): string {
    if (!this.control?.value || !this.data?.length) return "";

    // assume control.value is an array of ids
    const firstId = this.control.value[0];
    const match = this.data.find((opt) => opt.id === firstId);

    return match ? match.name : "";
  }

  private _filter(name: string): Option[] {
    const filterValue = name.toLowerCase();
    return this.data.filter((option) => option.name.toLowerCase().includes(filterValue));
  }

  selectionChange(event: any, option: Option) {
    if (event.isUserInput) {
      const current: number[] = this.control.value || [];
      if (event.source.selected) {
        this.control.patchValue([...current, option.id]);
      } else {
        this.control.patchValue(current.filter((id) => id !== option.id));
      }
    }
  }
}
